// Build-time constants injected by Vite's `define` (see vite.config.ts).
// Re-exported with stable names so app code does not depend on the global
// shape — and so tests can mock the values.
declare const __APP_COMMIT__: string;
declare const __APP_BUILD_TIME__: string;

export const APP_COMMIT: string = __APP_COMMIT__;
export const APP_BUILD_TIME: string = __APP_BUILD_TIME__;
